import { createDesktopOverlayRoom } from "@bezoned/desktop-bridge/bridge-common.js";
import { useEffect, useMemo } from "react";

import { useAuth } from "../auth/use-auth.js";
import { DesktopBridgeRoomContext } from "./desktop-bridge-room.context.js";
import { getOrCreateDesktopBridgeDeviceId } from "./desktop-bridge-sync.utils.js";
import { useDesktopBridge } from "./use-desktop-bridge.js";

interface DesktopBridgeRoomProviderProps {
  children: React.ReactNode;
}

export const DesktopBridgeRoomProvider = ({
  children,
}: DesktopBridgeRoomProviderProps) => {
  const { user } = useAuth();
  const { joinRoom, leaveRoom } = useDesktopBridge();
  const deviceId = useMemo(() => getOrCreateDesktopBridgeDeviceId(), []);

  const room = useMemo(
    () =>
      createDesktopOverlayRoom({
        deviceId,
        tenantId: user.tenantId,
        userId: user.id,
      }),
    [deviceId, user.id, user.tenantId]
  );

  useEffect(() => {
    joinRoom(room);

    return () => {
      leaveRoom(room);
    };
  }, [joinRoom, leaveRoom, room]);

  const contextValue = useMemo(
    () => ({
      __ctx_init: true,
      room,
    }),
    [room]
  );

  return (
    <DesktopBridgeRoomContext.Provider value={contextValue}>
      {children}
    </DesktopBridgeRoomContext.Provider>
  );
};
